import React from 'react'
import LineIcon from "react-lineicons"

interface ServiceContent {
  icon: string
  title: string
  details: string
}

interface ServiceProps {
  content: ServiceContent
}

const Service: React.FC<ServiceProps> = ({ content }) => {
  return (
    <div className="mi-service">
      <span className="mi-service-icon">
        <LineIcon name={content.icon} />
      </span>
      <h5>{content.title}</h5>
      <p>{content.details}</p>
    </div>
  )
}

export default Service
